import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { computed, observable } from 'mobx';
import { useRequest } from 'ahooks';
import getFooterYear from '@src/utils/get-footer-year';
import useModal from '@src/utils/hooks/use-modal';
import CookieTipsModal from './cookie-modal/cookie-tips-modal';
import { autobind } from 'core-decorators';
import Cookie from '@src/utils/cookie';
import CookieTipsModalStore, { COOKIE_FLAG } from './cookie-modal/cookie-tips-modal/store';
import { useEffect } from 'react';
import Config from './config';
import LanguageSelectStore from '@src/business-components/common-language-select/store';
import ToTopBtnStore from '@src/business-components/to-top-btn/store';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import langLocalesData from './langconfig.json';
import SHARE_METHOD_CONFIG from './followUs';
import { noop } from '@src/utils/common-util';
const lang = getLanguageByPath();
const footerLocales = langLocalesData[lang].common_footer;

class FooterStore extends BaseStore {
  constructor(options = {}) {
    super(options);
    Object.assign(this, options);
  }
  cookieTipModalStore = new CookieTipsModalStore();

  languageSelectStore = new LanguageSelectStore();

  //滚动到顶部
  @observable scrollToTop = noop;

  //是否需要渲染媒体列表
  @observable isRenderMediaList = false;

  // 当前年份
  @observable currentYear;

  //底部truste图标
  @observable footerLeftLogo = Config[lang]?.footerLeftLogo || [];

  //头部Logo
  @observable footerTopLogo = Config[lang]?.footerTopLogo || [];

  //协议跳转
  @observable agreementLinks = Config[lang].agreementLinks;

  //媒体跳转
  @computed
  get itemList() {
    return SHARE_METHOD_CONFIG.filter(item => item.applyLanguages.includes(lang))
      .sort((a, b) => a.order[lang] - b.order[lang])
      .map(item => ({
        name: item.name,
        link: item.linkLocales[lang],
        img: item.img,
        onClick: item.onClick
      }));
  }

  //版权信息
  get footerTextInfo() {
    return [
      { href: '', text: `Copyright © ${this.currentYear} ${footerLocales.corporation}` },
      { href: '', text: footerLocales.purchase },
      { href: '', text: footerLocales.zh_text }
    ];
  }

  //回到顶部按钮
  toTopBtnStore = new ToTopBtnStore();

  /**
   * 获取年份
   * @returns {Promise<void>}
   */
  async getYear() {
    try {
      const year = await this.getCurrentYearRequest.run();
      this.currentYear = year;
    } catch (e) {
      // console.log(e);
    }
  }

  @observable cookieFlagInfo;
  /**
   * 是否允许cookies
   * @type {{analytics: boolean, necessary: boolean}}
   */
  @observable
  acceptCookies = {
    necessary: true,
    analytics: false
  };

  /**
   * 是否存在CookieFlag
   * @returns {boolean}
   */
  @computed
  get hasCookieFlag() {
    return !!this.cookieFlagInfo;
  }

  @autobind
  getCookieFlag() {
    this.cookieFlagInfo = Cookie.get(COOKIE_FLAG);
  }

  @autobind
  handleCookieSetting() {
    this.reInit();
    this.cookieTipModalStore.isDirectToSettingModal = true;
    this.cookieTipModal.open({ extraProps: { store: this.cookieTipModalStore } });
  }

  @autobind
  reInit() {
    this.getCookieFlag();
    if (this.hasCookieFlag) {
      const info = JSON.parse(this.cookieFlagInfo);
      this.acceptCookies.necessary = info.necessary;
      this.acceptCookies.analytics = info.analytics;
    }
  }
  /**
   * 点击跳转
   * @param url
   */
  @autobind
  onRedirectLink(url) {
    if (url) {
      window.open(url);
    }
  }
  @autobind
  init() {
    if (this.hasCookieFlag) {
      const info = JSON.parse(this.cookieFlagInfo);
      this.acceptCookies.necessary = info.necessary;
      this.acceptCookies.analytics = info.analytics;
    } else {
      clearTimeout(this.cookieTipModalTimeout);
      this.cookieTipModalTimeout = setTimeout(() => {
        this.cookieTipModal.open();
      }, 1000);
    }
  }

  use() {
    super.use();
    // 如果scrollToTop被赋值了，且是函数则赋值给toTopBtnStore的scrollToTop
    if (this.scrollToTop !== noop && typeof this.scrollToTop === 'function') {
      this.toTopBtnStore.scrollToTop = this.scrollToTop;
    }

    this.getCurrentYearRequest = useRequest(async () => await getFooterYear(), { manual: true, throwOnError: true });
    this.cookieTipModal = useModal(CookieTipsModal);

    useMount(async () => {
      this.getYear();
      this.getCookieFlag();
      this.init();
    });
    useEffect(
      () => {
        this.cookieTipModalStore.acceptCookies.analytics = this.acceptCookies.analytics;
        this.cookieTipModalStore.acceptCookies.necessary = this.acceptCookies.necessary;
      },
      [this.acceptCookies.analytics, this.acceptCookies.necessary]
    );
  }
}

export default FooterStore;
